import { render, staticRenderFns } from "./purchase-matrix-operations.vue?vue&type=template&id=62c14afd&"
import script from "./js/purchase-matrix-operations.js?vue&type=script&lang=js&"
export * from "./js/purchase-matrix-operations.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports